import { createBrowserRouter, Navigate } from "react-router";
import { AppShell } from "./AppShell";
import { RootErrorBoundary } from "./RootErrorBoundary";
import { AuthGate } from "../features/auth/AuthGate";
import { LoginPage } from "../features/auth/LoginPage";
import { BusinessCardPage } from "../features/business-card/BusinessCardPage";
import { DesignSystemPage } from "../features/design-system/DesignSystemPage";
import { DiscordBusinessCardExportPage } from "../features/discord/DiscordBusinessCardExportPage";
import { DiscordDirectExportPage } from "../features/discord/DiscordDirectExportPage";
import { DiscordSnapshotPage } from "../features/discord/DiscordSnapshotPage";
import { EmployeesPage } from "../features/employees/EmployeesPage";
import { GeneratorWorkspacePage } from "../features/generator/GeneratorWorkspacePage";
import { HelpPage } from "../features/help/HelpPage";
import { HistoryPage } from "../features/history/HistoryPage";
import { ManualRoundBuilderRoute } from "../features/manual-builder/ManualRoundBuilderRoute";
import { TournamentWorkspacePage } from "../features/preparation/TournamentWorkspacePage";
import { ModulePlaceholderPage } from "../features/placeholders/ModulePlaceholderPage";
import { SystemPage } from "../features/system/SystemPage";

export const router = createBrowserRouter([
  { path: "/login", Component: LoginPage, ErrorBoundary: RootErrorBoundary, handle: { title: "Logowanie", section: "System" } },
  { path: "/wizytowka", Component: BusinessCardPage, ErrorBoundary: RootErrorBoundary },
  { path: "/__discord-wizytowka", Component: DiscordBusinessCardExportPage, ErrorBoundary: RootErrorBoundary },
  { path: "/__discord-export", Component: DiscordDirectExportPage, ErrorBoundary: RootErrorBoundary },
  { path: "/__discord-snapshot", Component: DiscordSnapshotPage, ErrorBoundary: RootErrorBoundary },
  {
    Component: AuthGate,
    ErrorBoundary: RootErrorBoundary,
    children: [{
      path: "/",
      Component: AppShell,
      children: [
        { index: true, element: <Navigate to="/tournaments" replace /> },
        { path: "tournaments", Component: TournamentWorkspacePage, handle: { title: "Turnieje", section: "Operacje" } },
        { path: "employees", Component: EmployeesPage, handle: { title: "Pracownicy", section: "Operacje" } },
        { path: "generator", Component: GeneratorWorkspacePage, handle: { title: "Generator rundy", section: "Operacje" } },
        { path: "manual", Component: ManualRoundBuilderRoute, handle: { title: "Manualny kreator", section: "Operacje" } },
        { path: "history", Component: HistoryPage, handle: { title: "Historia", section: "Operacje" } },
        { path: "help", Component: HelpPage, handle: { title: "Instrukcja", section: "System" } },
        { path: "system", Component: SystemPage, handle: { title: "Konta i system", section: "System" } },
        { path: "design-system", Component: DesignSystemPage, handle: { title: "Design System", section: "Foundation" } },

        { path: "tournaments/team", element: <Navigate to="/tournaments?tab=team" replace /> },
        { path: "tournaments/logistics", element: <Navigate to="/tournaments?tab=logistics" replace /> },
        { path: "team", element: <Navigate to="/tournaments?tab=team" replace /> },
        { path: "logistics", element: <Navigate to="/tournaments?tab=logistics" replace /> },

        { path: "round", element: <Navigate to="/generator" replace /> },
        { path: "round/generator", element: <Navigate to="/generator" replace /> },
        { path: "round/edit", element: <Navigate to="/generator?tab=board" replace /> },
        { path: "round/transport", element: <Navigate to="/generator?tab=transport" replace /> },
        { path: "round/transport/edit", element: <Navigate to="/generator?tab=transport-edit" replace /> },
        { path: "round/export", element: <Navigate to="/generator?tab=export" replace /> },
        { path: "round/versions", element: <Navigate to="/generator?tab=versions" replace /> },
        { path: "rounds", element: <Navigate to="/generator?tab=versions" replace /> },
        { path: "transport", element: <Navigate to="/generator?tab=transport" replace /> },
        { path: "reports", element: <Navigate to="/generator?tab=export" replace /> },

        { path: "*", element: <ModulePlaceholderPage label="Nie znaleziono strony" description="Ta route nie istnieje w aktualnym workflow aplikacji." />, handle: { title: "Nie znaleziono", section: "System" } },
      ],
    }],
  },
]);
